import { Quickbooks } from "@/interfaces/quickbooks";
import { messagesService } from "@/services/messages.service";
import { AxiosResponse } from "axios";
import Cookie from "js-cookie";
import Vue from "vue";
import HttpService from "./http.service";
class QuickbooksService extends HttpService {
  public async getIntegration(idIntegration: number) {
    this.uri = `/external_services/${idIntegration}/integrations`;
    const query = {
      ...this.query,
      no_pagination: true,
      embed: "integrationByLocations.location"
    };
    try {
      const resp = await super.get(query);
      return resp.data;
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }

  public async quickbookEnabled(idIntegration: number) {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: `/external_services/${idIntegration}/integrations`,
        data: {
          is_active: true
        },
        params: {
          embed: "integrationByLocations.location"
        }
      });
      return response.data.data;
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }

  public async saveIntegration(quickbooks: Quickbooks) {
    try {
      this.query.embed = "integrationByLocations.location";
      const response: AxiosResponse = await Vue.axios({
        method: "PUT",
        url: `/external_services/${
          quickbooks![0].external_service_id
        }/integrations/${quickbooks![0].id}`,
        data: quickbooks![0],
        params: {
          embed: "integrationByLocations.location",
          no_pagination: true
        }
      });
      return response.data.data;
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }
  public async putIntegration(idIntegration: number) {
    this.uri = `/integrations/${idIntegration}`;
    const query = {
      ...this.query,
      no_pagination: true,
      embed: "integrationByLocations.location"
    };
    try {
      const resp = await super.get(query);
      return resp.data;
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }

  public async revoke(idIntegration: number) {
    try {
      await Vue.axios({
        method: "PATCH",
        url: `/external_services/${idIntegration}/revoke_access`
      });
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }

  public async connect() {
    this.uri = `${process.env.VUE_APP_BASE_URL_ACCOUNTING}/quickbooks/connect`;
    const resp = await super.get(this.query);
    try {
      if (resp.data) {
        Cookie.set("quickbooks_redirect", "1", {
          domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
        });
        Cookie.set(
          "quickbooks_callback_data_url",
          `${
            process.env.VUE_APP_CORE_FRONTEND
          }/application-management/location-api`,
          {
            domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
          }
        );
        Cookie.set(resp.data.cookie_data.key, resp.data.cookie_data.value, {
          domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`,
          expires: new Date(resp.data.cookie_data.ttl)
        });
        window.location.href = resp.data.url;
      }
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }

  public async verifyIntegration(idIntegration: number) {
    delete this.query.no_pagination;
    delete this.query.embed;
    this.uri = `/external_services/${idIntegration}/check`;
    try {
      const resp = await super.get(this.query);
      return resp.data.data;
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }
}

export const quickbooksService = new QuickbooksService();
